import leeCoreLexEpicClient from 'bundles/epic/clients/leeCoreLex';

/*
 * This file includes utilities to check whether specific features should be enabled in the account-profile bundle.
 */

export const shouldEnableUniversityFreeTextDropdown = () =>
  leeCoreLexEpicClient.get('enableUniversityFreeTextDropdown');
